import {
  AirPriceFreezePurchaseState,
  CheckoutMapComponent,
} from "@hopper-b2b/checkout";
import { CartFulfillComponent } from "./CartFulfillComponent";
import { CartQuoteComponent } from "./CartQuoteComponent";
import { Confirmation } from "./Confirmation";
import { PaymentLoader } from "./PaymentLoader";
import { PriceFreezeOffer } from "./PriceFreezeOffer";

export const priceFreezeComponentMap = {
  [AirPriceFreezePurchaseState.priceFreezeOffer]: {
    state: AirPriceFreezePurchaseState.priceFreezeOffer,
    component: PriceFreezeOffer,
  },
  [AirPriceFreezePurchaseState.cartQuote]: {
    state: AirPriceFreezePurchaseState.cartQuote,
    component: CartQuoteComponent,
  },
  [AirPriceFreezePurchaseState.payment]: {
    state: AirPriceFreezePurchaseState.payment,
    component: PaymentLoader,
  },
  [AirPriceFreezePurchaseState.cartFulfill]: {
    state: AirPriceFreezePurchaseState.cartFulfill,
    component: CartFulfillComponent,
  },
  [AirPriceFreezePurchaseState.fulfillFailed]: {
    state: AirPriceFreezePurchaseState.fulfillFailed,
    component: CartFulfillComponent,
  },
  [AirPriceFreezePurchaseState.confirmation]: {
    state: AirPriceFreezePurchaseState.confirmation,
    component: Confirmation,
  },
};

export const PFCheckoutComponent = () => {
  return <CheckoutMapComponent componentMap={priceFreezeComponentMap} />;
};
